import React from 'react';
import './RefundPolicy.css';

export default function RefundPolicy() {
  return (
    <div className="refund-page" lang="en">
      <div className="refund-container">
        <h1 className="refund-title">Refund Policy</h1>

        <h2>Refund Eligibility</h2>
        <p>
          Users may request a refund before their account is activated. Once the account is activated, no refunds will be issued.
        </p>

        <h2>Requesting a Refund</h2>
        <p>
          To request a refund, users should email our support team at{' '}
          <a href="mailto:koreansir@gmail.com">koreansir@gmail.com</a> before their account is activated.
          We will review the request and respond within 5 business days.
          If the request is approved, we will refund the user&apos;s original payment method within 7 business days.
        </p>

        <h2>Reason for Refund</h2>
        <p>
          We will issue a refund if a user changes their mind about the subscription and decides not to activate their account.
          However, no refunds will be issued if a user activates their account and then decides to cancel their subscription.
        </p>

        <p className="refund-note">Korean Sir is owned by Aoura Network.</p>
      </div>
    </div>
  );
}
